module.exports = __webpack_public_path__ + "img/welcomes-all-white.1a4e537d.png";